/*
 * This page exists because directly embedding a Youtube video on audi.com.au is a PITA
 */

import React from 'react';
import Layout from '../components/Layout';

class VideoWidget extends React.Component {
    render() {
        const {videoType, videoId} = this.props.match.params;
        let videoSrc = "";
        if (videoType === 'youtube') {
            videoSrc = `https://www.youtube.com/embed/${videoId}${this.props.location.search}`;
        }
        return (
            <Layout embedded wide>
                <div style={{position: "relative", paddingBottom: "56.25%", height: "0"}}>
                    <iframe style={{position: "absolute", top: "0", left: "0", width: "100%", height: "100%"}} width="560" height="315" src={videoSrc} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
            </Layout>
        );
    }
}

export default VideoWidget;
